import { PropsWithChildren } from "react";
import BsCard, { CardProps as BsCardProps } from "react-bootstrap/Card";

import styles from "./Card.module.css";

export type CardProps = PropsWithChildren<{}> & BsCardProps;

const Card = ({ className, children, ...rest }: CardProps) => {
  return (
    <BsCard className={`${styles.card} ${className} p-2 shadow-sm`} {...rest}>
      {children}
    </BsCard>
  );
};

export default Card;
